import { useEffect, useMemo } from 'react';

import authService from 'src/services/api/auth.service';
import { useGetUserClassesQuery } from 'src/store/api/onboarding';
import {
  setActiveUserClasses,
  useActiveUserClassesSelector,
} from 'src/store/features';
import { useAppDispatch } from 'src/store/redux';
import { sortClassesByGradesInDesc } from 'src/utils/class-picker.utils';

export const useActiveUserClasses = () => {
  const userBk = authService.getUserBk();

  const dispatch = useAppDispatch();

  const activeUserClasses = useActiveUserClassesSelector();

  const {
    data: userClasses,
    isLoading,
    isError,
  } = useGetUserClassesQuery(userBk);

  const sortedClasses = useMemo(() => {
    return sortClassesByGradesInDesc(userClasses ?? []);
  }, [userClasses]);

  useEffect(() => {
    if (isLoading) return;
    const sortedClassesString = JSON.stringify(sortedClasses);
    const activeUserClassesString = JSON.stringify(activeUserClasses);

    // used to prevent unnecessary updates to the activeUserClasses state.
    if (sortedClassesString !== activeUserClassesString) {
      dispatch(setActiveUserClasses(sortedClasses));
    }
  }, [isLoading, sortedClasses, activeUserClasses, dispatch]);

  return { activeUserClasses, isLoading, isError };
};
